module.exports = __webpack_public_path__ + "img/atlaslist5img7.40cc45d4.jpg";